import { useContext } from "react";
import { observer } from "mobx-react-lite";

import { RunButton, RunInCLIButton } from "@components";

import { EditorWrapper } from "@pages/editor/components/EditorWrapper";
import { DEFAULT_MONACO_OPTIONS } from "@pages/editor/constants";
import { WorkbenchContext } from "@pages/editor/providers";

import { MonacoEditor } from "src/monaco";

const Editor = () => {
  const { workbench } = useContext(WorkbenchContext);
  const { bundle, editors } = workbench;

  if (bundle === null) return null;

  const { language, targetText, setTargetText } = bundle;

  return (
    <EditorWrapper
      id="target-editor"
      controls={
        <>
          {workbench.addressString ? (
            <RunInCLIButton
              snippetId={workbench.addressString}
              isUnsaved={workbench.hasUnsavedChanges}
            />
          ) : null}
          <RunButton
            isRunning={bundle.isRunning}
            onClick={bundle.run}
            // disable when bundle.rule is missing, it can happen for example when the rule is not valid
            disabled={!bundle.rule}
          />
        </>
      }
    >
      <MonacoEditor
        value={targetText}
        onChange={(value) => {
          if (value !== undefined) setTargetText(value);
        }}
        onMount={editors.onTargetEditorMount}
        language={language ?? undefined}
        options={{ ...DEFAULT_MONACO_OPTIONS }}
      />
    </EditorWrapper>
  );
};
export const TargetEditor = observer(Editor);
